import { Navigate } from "react-router-dom";
import AuthAppleSetup from "../pages/AuthAppleSetup";
import AuthLinkedInCallback from "../pages/AuthLinkedInCallback";
import AuthLogin from "../pages/AuthLogin";
import AuthRecoverRequest from "../pages/AuthRecoverRequest";
import AuthRecoverReset from "../pages/AuthRecoverReset";
import AuthRecoverSuccess from "../pages/AuthRecoverSuccess";
import AuthRecoverVerify from "../pages/AuthRecoverVerify";
import AuthSignup from "../pages/AuthSignup";
import BookDemoPage from "../pages/BookDemoPage";
import ProductOnboardingPage from "../pages/ProductOnboardingPage";
import PublicProductPage from "../pages/PublicProductPage";
import LandingPage from "../pages/care/LandingPage";
import PricingPage from "../pages/care/PricingPage";
import { CareShell } from "../components/care/CareLayout";

function PublicShellRoute({ children }) {
  return <CareShell className="dashboard-content app-page-content">{children}</CareShell>;
}

export const publicRoutes = [
  { path: "/", element: <LandingPage /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/login", element: <AuthLogin /> },
  { path: "/book-a-demo", element: <BookDemoPage /> },
  { path: "/get-started", element: <ProductOnboardingPage /> },
  { path: "/auth/signup", element: <AuthSignup /> },
  { path: "/auth/linkedin/callback", element: <AuthLinkedInCallback /> },
  { path: "/auth/apple-setup", element: <AuthAppleSetup /> },
  { path: "/auth/social-setup", element: <AuthAppleSetup /> },
  { path: "/auth/forgot-password", element: <Navigate to="/auth/recover" replace /> },
  { path: "/auth/recover", element: <AuthRecoverRequest /> },
  { path: "/auth/verify", element: <AuthRecoverVerify /> },
  { path: "/auth/reset", element: <AuthRecoverReset /> },
  { path: "/auth/recovered", element: <AuthRecoverSuccess /> },
  { path: "/auth/session-expired", element: <AuthLogin /> },
  { path: "/auth/logout", element: <Navigate to="/login" replace /> },
  { path: "/privacy-policy", element: <PublicShellRoute><PublicProductPage /></PublicShellRoute> },
];
